import { render, staticRenderFns } from "./MdmSoftwareDownRecord.vue?vue&type=template&id=15dc91d2&"
import script from "./MdmSoftwareDownRecord.vue?vue&type=script&lang=js&"
export * from "./MdmSoftwareDownRecord.vue?vue&type=script&lang=js&"
import style0 from "./MdmSoftwareDownRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports